import type { SportIconKey } from '../../components/SportIcon/SportIcon';

export type { SportIconKey };

// Above this sponsor count the logo row switches from a static row to a
// marquee. Shared by the desktop info panel and the mobile feature card.
export const SPONSORS_MARQUEE_THRESHOLD = 5;

export type Product = {
    id: string;
    brand: string;
    title: string;
    price: string;
    image: string;
    url: string;
};

export type Athlete = {
    id: string;
    name: string;
    firstName: string;
    lastName: string;
    sport: string;
    sportIcon: SportIconKey;
    // Uploaded icon URL from the shared sports catalog; null falls back to the built-in SVG.
    sportIconUrl?: string | null;
    previewImage: string;
    expandedVideo: string;
    // Mobile-encoded expanded video; empty string falls back to expandedVideo.
    mobileExpandedVideo: string;
    posterImage: string;
    // Mobile poster; empty string falls back to posterImage.
    mobilePosterImage: string;
    products: Product[];
    sponsors: string[];
    isFavesAthlete: boolean;
};
